// store/user/idol.slice.ts
import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { toggleIdolApi } from "apis/UserServiceApi";

interface IdolState {
  togglingIds: number[]; // ids en proceso
  idols: Record<number, boolean>; // { [userId]: isIdolized }
  error: string | null;
}

const initialState: IdolState = {
  togglingIds: [],
  idols: {},
  error: null,
};
export const toggleIdol = createAsyncThunk(
  "idol/toggle",
  async (idolUserId: number, { rejectWithValue }) => {
    try {
      const res = await toggleIdolApi(idolUserId);
      return { idolUserId, ...res };
    } catch (err: any) {
      return rejectWithValue(err.message ?? "Error");
    }
  }
);
const idolSlice = createSlice({
  name: "idol",
  initialState,
  reducers: {},
  extraReducers: (b) => {
    b.addCase(toggleIdol.pending, (st, { meta }) => {
      st.togglingIds.push(meta.arg);
      st.error = null;
    })
      .addCase(toggleIdol.fulfilled, (st, { payload }) => {
        st.togglingIds = st.togglingIds.filter(
          (id) => id !== payload.idolUserId
        );
        st.idols[payload.idolUserId] = payload.isIdolized;
      })
      .addCase(toggleIdol.rejected, (st, { meta, payload }) => {
        st.togglingIds = st.togglingIds.filter((id) => id !== meta.arg);
        st.error = payload as string;
      });
  },
});

export const idolReducer = idolSlice.reducer;
